import { Descriptions, Button } from 'antd';
import React, { useState } from 'react';
import { BoxArrowInUpRight, Wrench } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import GoogleMapReact from 'google-map-react';
import constants from '../../constants';
import Marker from '../Marker';
import TableView from '../tableView';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab
} from '@mui/material';
import { a11yProps, TabPanel } from './TabPanel';
import '../../pages/Sensors/sensors.scss';
import Paragraph from 'antd/lib/typography/Paragraph';
import { accountLink } from '../../utils/nodeExplorer';
interface Props {
  showModal: boolean;
  closeModal: Function;
  row: any;
  name: string | undefined;
  fixSensorPin: Function;
  formatDate: Function;
  setOpenLastData: Function;
  openLastData: boolean;
  selectedRow: any;
  lat: number | undefined;
  lng: number | undefined;
}

const SensorInfoViewModal = ({
  showModal,
  closeModal,
  row,
  name,
  fixSensorPin,
  formatDate,
  setOpenLastData,
  openLastData,
  selectedRow,
  lat,
  lng
}: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const sensorsLicensesColumns = [
    {
      title: t('NFT'),
      field: 'nft',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('TYPE'),
      field: 'type',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ACTIVATION_DATE'),
      field: 'activationDate',
      sorter: 'string',
      formatter: (cell: any) => formatDate(cell.getValue()),
      headerFilter: 'input'
    },
    {
      title: t('EXPIRATION_DATE'),
      field: 'expirationDate',
      sorter: 'string',
      formatter: (cell: any) => formatDate(cell.getValue()),
      headerFilter: 'input'
    }
  ];

  const handleChange = (e: any, newValue: number) => {
    setValue(newValue);
  };

  console.log(row);

  return (
    <>
      <Dialog className='dialog' open={showModal} onClose={() => closeModal()}>
        <DialogTitle >{row?.sensor_id}</DialogTitle>
        <DialogContent>
          <Tabs value={value} onChange={handleChange}>
            <Tab label={t('INFO')} {...a11yProps(0)} />
            <Tab label={t('LICENSES')} {...a11yProps(1)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Descriptions size="small" bordered>
              <Descriptions.Item span={2} label={<b>{t('SENSOR_NAME')}:</b>}>
                {name ? <Paragraph copyable={{ tooltips: false }}>{name}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('TYPE')}:</b>}>
                {row?.type ? <Paragraph copyable={{ tooltips: false }}>{row.type}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('MAIL')}:</b>}>
                {row?.mail ? <Paragraph copyable={{ tooltips: false }}>{row.mail}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('PIN')}:</b>}>
                {row?.pin ? <Paragraph copyable={{ tooltips: false }}>{row.pin}</Paragraph> : '-'}
                {row && row.pin !== undefined && row.pin !== null && row.pin.startsWith('0') && (
                  <Button className='fix-pin-btn' type='link' onClick={() => fixSensorPin(row.id)}>
                    <Wrench height={20} />
                  </Button>
                )}</Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('LAST_UPDATE')}:</b>}>
                {row?.last_update ? <Paragraph copyable={{ tooltips: false }}>{formatDate(row.last_update)}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('LAST_ACCESS')}:</b>}>
                {row?.last_access ? <Paragraph copyable={{ tooltips: false }}>{formatDate(row.last_access)}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item label={<b>{t('DATA_COLLECTED')}:</b>}>
                {row?.data_collected ? <Paragraph copyable={{ tooltips: false }}>{row.data_collected}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('GEO')}:</b>}>
                {row?.geo ? <Paragraph copyable={{ tooltips: false }}>{row.geo}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('NFT')}:</b>}>
                {row?.NFTassetID ? <Paragraph copyable={{ tooltips: false }}>{row.NFTassetID}</Paragraph> : '-'}
              </Descriptions.Item>
              <Descriptions.Item span={3} label={<b>{t('ALGORAND_ACCOUNT')}:</b>}>
                {row ? row.algo_account : '-'}
                {row?.algo_account &&
                  <a href={accountLink(row?.algo_account)} target="_blank">
                    <BoxArrowInUpRight></BoxArrowInUpRight></a>}
              </Descriptions.Item>
              <Descriptions.Item span={3} label={<b>{t('ALGORAND_INFRASTRUCTURE_ACCOUNT')}:</b>}>
                {row ? row.algo_account_infra : '-'}
                {row?.algo_account_infra && <a href={accountLink(row?.algo_account_infra)} target="_blank">
                  <BoxArrowInUpRight></BoxArrowInUpRight></a>}
              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('CITY')}:</b>}>
                {row?.city ? <Paragraph copyable={{ tooltips: false }}>{row.city}</Paragraph> : '-'}

              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('REGION')}:</b>}>
                {row?.province ? <Paragraph copyable={{ tooltips: false }}>{row.province}</Paragraph> : '-'}

              </Descriptions.Item>
              <Descriptions.Item span={2} label={<b>{t('COUNTRY')}:</b>}>
                {row?.country ? <Paragraph copyable={{ tooltips: false }}>{row.country}</Paragraph> : '-'}

              </Descriptions.Item>
            </Descriptions>

            {row?.last_data !== null && (
              <Button
                style={{ marginTop: 10, marginBottom: 10 }}
                onClick={() => setOpenLastData(!openLastData)}
              >
                {t('LAST_DATA')}
              </Button>
            )}
            {openLastData && (
              <div>
                <pre
                  style={{
                    height: '250px',
                    overflow: 'hidden',
                    overflowY: 'scroll'
                  }}
                >
                  {row
                    ? JSON.stringify(JSON.parse(row.last_data), undefined, 2)
                    : '-'}
                </pre>
              </div>
            )}

            {lat && lng && (
              <div className="map">
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: 'AIzaSyBTtp6t0kxEJ2nENMW4U1llK_FYHNAvrgk'
                  }}
                  defaultCenter={{ lat, lng }}
                  defaultZoom={9}
                >
                  <Marker lat={lat} lng={lng} name={name!} />
                </GoogleMapReact>
              </div>
            )}
          </TabPanel>
          <TabPanel value={value} index={1}>
            <TableView
              t={t}
              id={'licences'}
              api={constants.api.getSensorLicenses.replace(
                ':sensorId',
                Number(selectedRow?.id).toString()
              )}
              columns={sensorsLicensesColumns}
            />
          </TabPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SensorInfoViewModal;
